import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import PhoneHeader from "../../Components/Common/PhoneHeader";

function TicketSingle({ location }) {
  const history = useHistory();
  const data = location?.state;
  useEffect(() => {
    if (!data) {
      history.goBack();
    }
  }, [location]);
  return (
    <div className="Container" id="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          overflowY: "scroll",
        }}
      >
        <PhoneHeader text={"جزییات تیکت"} />
        <div className="divider" />
        <span className="TicketTitle">{data?.title}</span>
        <div className="divider" />
        <div className="shadowDiv singleTicketComponent">
          <span>متن ارسالی</span>
          <div className="divider" />
          <span>
            سلام وقت بخیر . بنده قبض برق منزل رو از طریق کنتور پرداخت کردم. مبلغ
            قبض از حساب بنده کم شده و پیام قبض با موفقیت پرداخت شد نیز نمایش
            داده شد اما در بخش استعلام، قبض پرداخت شده باز هم نشان داده می‌شود
          </span>
        </div>
        <div className="divider" />
        {data?.answer && (
          <div className="shadowDiv singleTicketComponent">
            <span>پاسخ پشتیبان</span>
            <div className="divider" />
            <span>
              سلام وقت بخیر . بنده قبض برق منزل رو از طریق کنتور پرداخت کردم.
              مبلغ قبض از حساب بنده کم شده و پیام قبض با موفقیت پرداخت شد نیز
              نمایش داده شد اما در بخش استعلام، قبض پرداخت شده باز هم نشان داده
              می‌شود
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default TicketSingle;
